/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LoginAccountInSysOrgDto } from '../models/LoginAccountInSysOrgDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LoginAccountManagementService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param sysOrgGuid
     * @param requestBody
     * @returns LoginAccountInSysOrgDto OK
     * @throws ApiError
     */
    public updateLoginAccountInSysOrg(
        sysOrgGuid: string,
        requestBody?: LoginAccountInSysOrgDto,
    ): CancelablePromise<LoginAccountInSysOrgDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/LoginAccountManagement/{sysOrgGuid}/UpdateLoginAccountInSysOrg',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param sysOrgGuid
     * @param userGuid
     * @returns LoginAccountInSysOrgDto OK
     * @throws ApiError
     */
    public deleteLoginAccountInSysOrg(
        sysOrgGuid: string,
        userGuid: string,
    ): CancelablePromise<LoginAccountInSysOrgDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/LoginAccountManagement/{sysOrgGuid}/{userGuid}/DeleteLoginAccountInSysOrg',
            path: {
                'sysOrgGuid': sysOrgGuid,
                'userGuid': userGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
